export const formatUsersOptionsGroup = (data: any): any => {
  return data && data.map((a: any) => ({ value: {id:a.id, name:a.fullName}, name: a.fullName }));
};